export const REFERRAL = 'referral';
export const PROMO = 'promo';
